import { get } from '@ember/object';

export default {
  // `models` is typically a DS.RecordArray return from the store
  //
  // Example usage
  // return get(this, 'store').findAll('user').then((users) => {
  //   return modelUtils.filterPersisted(users);
  // });
  filterPersisted(models) {
    return models.filter((model) => {
      return !get(model, 'isNew') && !get(model, 'isDeleted');
    });
  },
};
